import WindAssetActions from "./WindAssetActions";
import WindAssetMutations from "./WindAssetMutations";
import WindAssetGetters from "./WindAssetGetters";

const state = { windMonitoringElementsTree: [] };

const { actions } = WindAssetActions;

const { mutations } = WindAssetMutations;

const { getters } = WindAssetGetters;

const namespaced = true;

export default {
	namespaced,
	state,
	getters,
	actions,
	mutations,
};